import Vue from 'vue'

export default Vue.extend({
    data() {
        return {}
    },
    methods: {
        createToast(position, variant, append = false, title, message, noAutoHide = false, autoHideDelay = 2500) {
            this.$bvToast.toast(message, {
                title: title,
                toaster: position,
                variant: variant,
                autoHideDelay: autoHideDelay,
                noAutoHide: noAutoHide,
                appendToast: append,
                solid: true,
            })
        },
        handleErrors(errors) {
            errors.forEach((error) => {
                let message = error
                if (typeof error === 'object') message = `${error.name} ${error.field} ${error.message}`
                this.createToast('b-toaster-top-center', 'danger', true, 'Validation Error', message)
            })
        },
    },
})
